import React from 'react';
import withIcon from '../utilities/withIcon';

const IconFilter = () => {
  return (
    <g>
      <path d="M.752 0 .646.007a.75.75 0 0 0-.444 1.254l5.804 6.243v7.745a.75.75 0 0 0 1.04.692l2.489-1.04.1-.052a.75.75 0 0 0 .36-.641V7.493l5.802-6.231A.75.75 0 0 0 15.248 0H.752zm12.772 1.5L8.696 6.688l-.07.088a.75.75 0 0 0-.131.423l-.001 6.51-.987.412v-6.91L7.5 7.097a.75.75 0 0 0-.192-.399L2.472 1.5h11.052z" />
    </g>
  );
};

export default withIcon(IconFilter);
